<template>
  <message-details v-if="messageDetails" :messageDetails="messageDetails" />
  <div v-else><cl-spinner size="small" /></div>
</template>

<script>
import { mapGetters } from "vuex";

import MessageDetails from "@/views/Common/MessageOverview/Details";

export default {
  name: "DetailsTab",
  components: {
    MessageDetails,
  },
  computed: {
    ...mapGetters("message", ["messageDetails"]),
  },
};
</script>
